import { render, staticRenderFns } from "./contract-trans-nl.vue?vue&type=template&id=1283e2cb&scoped=true"
import script from "./contract-trans-nl.vue?vue&type=script&lang=js"
export * from "./contract-trans-nl.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=1283e2cb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283e2cb",
  null
  
)

export default component.exports